import React from 'react'
import {Link} from 'react-router-dom'
import {useAccountContext} from '../layout/AccountLayout'
import {useGetTicketsQuery} from '../../services/residentPortalApi'
import LoaderInline from '../common/LoaderInline'
import {Ticket} from '../../types/app-types'
import {formatDateString, sortBy} from '../../services/utils'
import {getNavigationPaths} from '../../services/navigation'
import Breadcrumbs from '../navigation/Breadcrumbs'

const SupportPage = () => {
  const {accountId, reservation} = useAccountContext()
  const paths = getNavigationPaths(accountId)
  const ticketsQuery = useGetTicketsQuery(reservation.id)
  const tickets: Ticket[] = ticketsQuery.data

  let content = null
  if (ticketsQuery.isLoading) {
    content = (
      <tr>
        <td colSpan={4}>
          <LoaderInline text="Loading support requests..." />
        </td>
      </tr>
    )
  } else if (tickets && tickets.length) {
    content = sortBy(tickets, 'created').map(
      ({id, created, subject, type, status}: Ticket) => {
        return (
          <tr key={id}>
            <td>{formatDateString(created)}</td>
            <td>{type}</td>
            <td>{subject}</td>
            <td>{status}</td>
          </tr>
        )
      }
    )
  } else {
    content = (
      <tr>
        <td colSpan={4}>No support requests</td>
      </tr>
    )
  }

  return (
    <section>
      <Breadcrumbs
        items={[
          {label: 'Account', path: paths.Account, active: false},
          {label: 'Resident Support', active: true}
        ]}
      />
      <div className="card-default w-full">
        <div className="card-body-default">
          <h1 className="card-header">Resident Support</h1>
          <div className="card-actions">
            <Link to={paths.AddSupportRequest} className="btn btn-primary">
              Create Support Request
            </Link>
          </div>
          <div className="overflow-x-auto mt-4">
            <table className="table w-full table-compact table-zebra">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Subject</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>{content}</tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SupportPage
